<app-header-container>
  <div class="d-flex justify-content-between" *ngIf="!isLoading; else loading">
    <div class="d-flex flex-column gap-2 gap-xl-3 my-auto">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
      <div class="d-flex justify-content-between">
        <div class="header-text">{{ headerTitle }}</div>
      </div>
    </div>
    <img *ngIf="employerLogoSrc" class="employer-logo" [src]="employerLogoSrc" alt="{{ headerTitle }} logo" i18n-alt />
  </div>
</app-header-container>

<ng-template #loading>
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column gap-2 my-auto">
      <lib-loading-shimmer [height]="'1rem'" [width]="'23.75rem'" />
      <lib-loading-shimmer class="title-shimmer" [height]="'1.5rem'" [width]="'21rem'" />
    </div>
    <lib-loading-shimmer [height]="'6.25rem'" [width]="'6.25rem'" />
  </div>
</ng-template>
